namespace $.$$ {

	export class $shm_hitalama_map_widget_float_code extends $.$shm_hitalama_map_widget_float_code {

		textarea_lazy_enabled() { return !this.auto_height() }

		private code_save_active = false
		private code_save_revision = 0
		private code_save_requested = ''

		enabled( next?: boolean ): boolean {
			return this.widget().enabled(next) ?? false
		}
		
		@ $mol_mem
		code_draft( next?: string | null ): string | null {
			return next ?? null
		}

		@ $mol_mem
		code( next?: string ): string {
			const draft = this.code_draft()
			if( next === undefined ) return draft ?? this.widget().code() ?? ''

			const current = draft ?? this.widget().code() ?? ''
			const may_use_file = Math.max( current.length, next.length ) >= $shm_hitalama_file_text_inline_limit / 4
			if( !may_use_file && this.widget().type() !== 'application' ) return this.widget().code( next ) ?? ''

			this.code_draft( next )
			this.code_save_request( next )
			return next
		}

		@ $mol_action
		code_save_request( next: string ) {
			this.code_save_requested = next
			++ this.code_save_revision
			if( this.code_save_active ) return
			this.code_save_start()
		}

		private code_save_start() {
			const revision = this.code_save_revision
			const value = this.code_save_requested
			this.code_save_active = true

			$mol_wire_async( this.widget() ).code( value ).then(
				()=> this.code_save_done( revision ),
				error => this.code_save_failed( revision, error ),
			)
		}

		@ $mol_action
		private code_save_done( revision: number ) {
			if( revision !== this.code_save_revision ) {
				this.code_save_start()
				return
			}

			this.code_save_active = false
			this.code_draft( null )
		}

		@ $mol_action
		private code_save_failed( revision: number, error: unknown ) {
			if( revision !== this.code_save_revision ) {
				this.code_save_start()
				return
			}

			this.code_save_active = false
			$mol_fail_log( error )
		}

		code_download_extension() {
			switch( this.widget().type() ) {
				case 'code_js': return 'js'
				case 'code_html': return 'html'
				case 'code_ts': return 'ts'
				case 'code_sql': return 'sql'
				case 'code_css': return 'css'
				default: return 'txt'
			}
		}

		code_download_file_name() {
			const title = this.title().trim().replace( /[\\/:*?"<>|]+/g, '_' ) || 'code'
			return `${ title }.${ this.code_download_extension() }`
		}

		code_download_blob() {
			return new Blob([ this.code() ], { type: 'text/plain;charset=utf-8' })
		}
		
		@ $mol_mem
		font_size( next?: number ) {
			return this.widget().font_size(next)
		}
		
		@ $mol_mem
		font_size_px() {
			return this.font_size() + 'px'
		}

		drag_overlap_pointer_events() {
			return 'none'
		}

		template_map() {
			const profile = $shm_hitalama_profile.current()
			const type = this.widget().type()

			if( type === 'code_sql' ) return profile?.templates_sql() ?? null
			if( [ 'code_ts', 'component', 'component_view', 'customdom' ].includes( type ) ) return profile?.templates_tsx() ?? null
			return profile?.templates_js() ?? null
		}

		@ $mol_mem
		template_widgets(): readonly $shm_hitalama_map_widget[] {
			const widgets = this.template_map()?.Widgets_list(null)?.remote_list() as readonly $shm_hitalama_map_widget[] | undefined
			return widgets?.filter( w => w.type() == this.widget().type() ) ?? []
		}
		
		@ $mol_mem
		template_dictionary() {
			return Object.fromEntries(
				this.template_widgets().map( widget => [ widget.link_str(), widget.title() ] )
			)
		}

		code_template( id: string ) {
			return this.template_widget( id )?.code() ?? ''
		}

		template_widget( id: string ) {
			return this.template_widgets().find( widget => widget.link_str() === id ) ?? null
		}

		template_title( id: string ) {
			return this.template_dictionary()[ id ] ?? id
		}

		template_selected( next?: string ) {
			if( next === undefined ) return ''

			const template = this.code_template( next )
			if( template ) {
				this.code( template )
				this.title( this.template_title( next ) )
			}

			return ''
		}

		no_crdt() {
			return this.widget().text_crdt_disabled()
		}

		disable_crdt_visible() {
			return this.widget().text_crdt_disabled() ? [] : super.disable_crdt_visible()
		}

		disable_crdt() {
			const code = this.widget().text()
			this.widget().text_crdt_disabled( true )
			this.widget().text( code )
			this.Map_page().contextmenu_showed( false )
		}

		widget_value_click( id: string, event?: MouseEvent ) {
			const widget = this.map().widget( id )
			if( this.$.$mol_state_arg.value( 'edit_mode' ) != null ) {
				this.$.$mol_state_arg.href( this.$.$mol_state_arg.link({
					... this.$.$mol_state_arg.dict(),
					edit_widget: widget.link().str,
				}) )
				this.$.$mol_state_arg.commit()
				return event ?? null
			}

			const target = widget.container_widget()?.type() == 'notebook'
				? widget.container_widget()!
				: widget

			this.Map_page().go_to_widget( target.link() )
			this.Map_page().selected( widget.link(), true )

			return event ?? null
		}

		run_click() {
			$mol_error_fence(
				()=> this.Bench().run(),
				( error )=> {
					console.error( error )
				}
			)

			new this.$.$mol_after_frame( ()=> {
				this.Content_scroll().dom_node().scrollTop = this.Textarea().dom_node().scrollHeight
			} )
		}

	}

}
